var resourceInjector = require('src/interlock/no-ui/utils/resource-injector/resource-injector');
var pageValues = require('src/interlock/no-ui/page-values/page-values');
var darklaunch = require('src/interlock/no-ui/utils/darklaunch/darklaunch');

var gptUrl = '//www.googletagservices.com/tag/js/gpt.js';
var defer;
var darklaunched = darklaunch.storyEnabled('TMT-163');

var setGoogleTag = function(){
    window.googletag = window.googletag||{};
    window.googletag.cmd = window.googletag.cmd||[];
};
/**
 *
 * Initialize gpt script on the page
 * @private
 */
var _init = function() {
    setGoogleTag();

    if (darklaunched) {
        if (_areAdsEnabled()) {
            window.googletag.cmd.push(function () {
                try {
                    initializeSettings();
                } catch (ex) {
                    //console.error('gptInstaller:_init', ex);
                    throw ex;
                }
            });

        }
    } else {
        if (_areAdsEnabled() && !_isGptIncluded()) {
            window.googletag.cmd.push(function() {
                try {
                    initializeSettings();
                } catch (ex) {
                    //console.error('gptInstaller:_init', ex);
                    throw ex;
                }
            });

            defer = resourceInjector.jsScript(gptUrl)
                .then(function success() {

                }, failedToInstall);
        } else {
            defer = Promise.reject({
                _areAdsEnabled: _areAdsEnabled()
            });
        }
        return defer;
    }
};

/**
 * Called if something is failed to install
 */
function failedToInstall() {
    // todo DO something on ad failure
}

/**
 * Set up initial settings when executive script is available on page
 * NOTE: Assumes gpt already loaded so either call it way after or wrapp it in a
 * googletag.cmd.push
 */
function initializeSettings() {
    window.googletag.pubads()
        .setCentering(true);

    _isCollapseEnabled() && window.googletag.pubads()
        .collapseEmptyDivs(true);
    _isAsyncRenderingEnabled() && window.googletag.pubads()
        .enableAsyncRendering();

    if (_isSraEnabled()) {
        window.googletag.pubads()
            .enableSingleRequest();
    }

    window.googletag.enableServices();
    window.googletag.companionAds()
        .setRefreshUnfilledSlots(true);
}

/**
 * Returns true if ads should collapse when no ad is targeted
 */
function _isCollapseEnabled() {
    return !_isDebugEnabled();
}

/**
 * True if the gpt script already included on the page.
 * @returns {boolean}
 * @private
 */
function _isGptIncluded() {
    return !!window.document.querySelector('[src="' + gptUrl + '"]');
}

/**
 * Returns true if SRA mode (single request mode) is enabled
 *
 * @return {Boolean} [description]
 */
function _isSraEnabled() {
    return !pageValues.values()._gpt.hasOwnProperty('noSra');
}

function _isAsyncRenderingEnabled() {
    return !pageValues.values()._gpt.hasOwnProperty('noAsyncRender');
}

/**
 * True if debug mode enabled
 *
 * @returns {boolean}
 * @private
 */
function _isDebugEnabled() {
    return pageValues.values()._gpt.hasOwnProperty('debug') || !_areAdsEnabled();
}

/**
 * True if ads are to be enabled.
 *
 * @returns {boolean}
 * @private
 */
function _areAdsEnabled() {
    return !(pageValues.values()._gpt.hasOwnProperty('disabled') && pageValues.values()._gpt.disabled);
}

/**
 *
 * Install GPT to application
 */
var install = function() {
    if (darklaunched) {
        return _init();
    }
    return defer ? defer : _init();

};


module.exports = {
    install: install,
    areAdsEnabled: _areAdsEnabled,
    isSraEnabled: _isSraEnabled,
    isCollapseEnabled: _isCollapseEnabled,
    isDebugEnabled: _isDebugEnabled
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/gpt-installer/gpt-installer.js
// module id = 449
// module chunks = 36